import { Wording } from '@/types';

export const LOVE_WORDING_FR: Wording = {
  components_header_media_content: 'Audios',
  components_header_media_1: 'Méditations',
  components_header_media_2: 'Podcast',
  components_header_text1: 'Guides',
  components_header_text2: 'Blog',
  components_header_members: 'Membres',
  hero_text: 'Découvrez l\'amour à travers les étoiles',
  hero_button_text: 'Commencez votre voyage',
  components_ressources_section_title: 'AMOUR ET ASTROLOGIE',
  components_ressources_subheader_text: 'Votre boîte à outils céleste pour une vision romantique',
  components_ressources_span_text: 'Plongez dans notre univers de podcasts et d\'articles centrés sur l\'amour, la compatibilité zodiacale et la connexion cosmique. Que vous cherchiez à trouver l\'âme sœur ou à décoder vos schémas relationnels, nos ressources vous guident vers une compréhension plus profonde grâce aux astres.',
  components_ressources_card_1_title: 'Discussions amoureuses sur le zodiaque',
  components_ressources_card_1_text: 'Découvrez des épisodes de podcast sincères explorant le langage émotionnel de chaque signe, la compatibilité amoureuse, la passion et la croissance personnelle dans les relations.',
  components_ressources_card_2_title: 'Blog d\'amour',
  components_ressources_card_2_text: 'Découvrez des idées et des réflexions sur la façon dont chaque signe aime, guérit et tisse des liens. De la synastrie à la romance planétaire, notre blog est votre guide pour l\'amour astrologique.',
  components_ressources_link: 'Explorer plus loin',
  components_notes_and_google_title_1: 'Astrologie romantique',
  components_notes_and_google_title_2: 'Habitudes amoureuses',
  components_notes_and_google_title_3: 'Réflexions amoureuses des auditeurs',
  components_review_google_text: 'Ce que disent nos auditeurs',
  media_content_section_title: 'PODCAST AMOUR & SIGNES DU ZODIAQUE',
  media_content_section_subheader_text: 'Discussions sérieuses sur la romance cosmique',
  text_media_1: 'Écoutez des épisodes profonds et révélateurs sur les correspondances astrologiques, les modèles émotionnels et la dynamique romantique.',
  text_media_2: '',
  media_content_section_button_more: 'Écoutez maintenant',
  text2_section_title: 'BLOG',
  text2_section_subheader_text: 'Histoires d\'amour et perspectives astrologiques',
  text2_section_button_more: 'Charger plus',
  components_text1_section_title: 'GUIDES',
  components_text1_subheader_text: '',
  components_text1_span_text: '',
  components_text1_card_1_title: '',
  components_text1_card_1_text: '',
  components_text1_card_3_title: '',
  components_text1_card_3_text: '',
  components_text1_card_2_title: '',
  components_text1_card_2_text: '',
  components_text1_link: '',
  components_footer_text: 'Laissez les étoiles guider votre histoire d\'amour',
  components_footer_info: 'Informations',
  components_footer_registration_number: 'Numéro d\'enregistrement',
  components_footer_legal: 'Légal',
  components_footer_terms: 'Termes et conditions',
  components_footer_privacy: 'politique de confidentialité',
  button_load_more: 'Charger plus',
  page_media_2_content_hero_text: '',
  page_media_content_menu_antistress: '',
  page_media_content_menu_mindfulness: '',
  page_media_content_menu_energyboost: '',
  page_media_content_menu_mantra: '',
  page_media_1_content_hero_text: 'Amour et Zodiaque : épisodes de podcast',
  page_media_content_menu_compatibility: 'Compatibilité',
  page_media_content_menu_love: 'Amour',
  page_text1_hero_text: '',
  page_text1_section_title: '',
  page_text1_subheader_text: '',
  page_text2_hero_text: 'Explorez l\'amour à travers l\'astrologie',
  page_text2_section_title: 'Blog',
  page_text2_subheader_text: 'Articles',
  enter_email_title: 'Veuillez entrer votre email pour continuer',
  enter_email_placeholder_email: 'E-mail',
  enter_email_button_enter: 'Entrer',
  components_login_success_text: 'Connexion réussie !',
  components_card_link_media_content: 'Écoutez maintenant',
  components_card_link_text2_content: 'Lire les articles',
  components_card_link_text1_content: '',
  france: 'France',
  cyprus: 'Chypre',
  tag_podcast: 'Podcast',
  tag_meditation: 'Méditation',
  page_media_content_menu_all: 'Tous',
};